module.exports = function() {
  return new Worker(__webpack_public_path__ + "4ade6faebbabb0c21ca3.worker.js");
};